<template>
  <div>
    <el-footer v-if="isPc" :class="{ isfixed: isfixed }">
      <el-main>
        <div class="association_detail">
          <div>
            <div class="link" v-if="$store.state.linkList.length > 0">
              <h5>友情鏈接：</h5>
              <ul>
                <li v-for="(item, index) in $store.state.linkList" :key="index">
                  <!-- <el-image
              :src="$imgUrl + item.image"
              fit="cover"
              @click="toOutSideUrl(`${item.url}`)"
            ></el-image> -->
                  <span @click="toOutSideUrl(`${item.url}`)">{{
                    item.name
                    }}</span>
                </li>
                <div class="clear"></div>
              </ul>
            </div>
            <div class="association_detail_left">
              <div class="el-icon-location-outline">
                地址: {{ infoRes.add }}
              </div>
              <div class="el-icon-phone-outline">電話：{{ infoRes.phone }}</div>
              <div class="el-icon-message">郵箱：{{ infoRes.email }}</div>
            </div>
          </div>

          <div class="association_detail_right">
            <ul>
              <li v-for="(item, index) in footerMenuList1" :key="index" @click="fnToIntroduce(item.url)">
                {{ item.name }}
              </li>
              <div class="vertical_line"></div>
            </ul>
            <ul>
              <li v-for="(item, index) in footerMenuList2" :key="index" @click="fnToIntroduce(item.url)">
                {{ item.name }}
              </li>
            </ul>
            <!-- <ul>
            <li v-for="(item, index) in footerMenuList3" :key="index" @click="fnToIntroduce(item.url)">
              {{ item.name }}
            </li>
          </ul> -->
          </div>
        </div>
        <div class="copyright_info">
          <p v-html="infoRes.copyright"></p>
          <p>技术支持：{{ infoRes.author }}</p>
        </div>
      </el-main>
    </el-footer>
    <div v-if="isfixed && isPc" style="height: 240px; width: 100%"></div>
    <el-footer v-if="!isPc" class="m-footer">
      <div class="association_detail_left">
        <div class="el-icon-phone-outline">電話：{{ infoRes.phone }}</div>
        <div class="el-icon-message">郵箱：{{ infoRes.email }}</div>
        <div class="el-icon-location-outline">地址: {{ infoRes.add }}</div>
      </div>
      <div class="qcode">
        <div class="qcode-item">
          <img :src="$imgUrl + infoRes.wxQrcode" alt="" />
          <p>微信</p>
        </div>
        <div class="qcode-item">
          <img src="../assets/images/i_shenzhen.png" alt="" />
          <p>i深圳</p>
        </div>
        <div class="qcode-item">
          <img src="../assets/images/tsh_qcode.png" alt="" />
          <p>台商匯</p>
        </div>
        <!-- <div class="qcode-item">
          <img
            src="../assets/images/shenitai_qcode.png"
            alt=""
          />
          <p>深i台</p>
        </div> -->
      </div>
      <div class="copyright_info">
        <p v-html="infoRes.copyright"></p>
        <p>技术支持：{{ infoRes.author }}</p>
      </div>
    </el-footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      isfixed: false,
      footerMenuList1: [
        {
          name: "協會簡介",
          url: "/introduce",
        },
        {
          name: "協會章程",
          url: "/regulations",
        },
        {
          name: "組織架構",
          url: "/organization",
        },
      ],
      footerMenuList2: [
        // {
        //   name: "协会领导",
        //   url:"/"
        // },
        {
          name: "協會聯誼會",
          url: "/fraternity",
        },
        {
          name: "功能委員會",
          url: "/committee",
        },
        {
          name: "加入協會",
          url: "/apply",
        },
      ],
      footerMenuList3: [
        // {
        //   name: "秘書處",
        //   url:"/secretariat"
        // },
        // {
        //   name: "加入協會",
        //   url:"/"
        // },
      ],
    };
  },
  computed: {
    ...mapState(["infoRes", "isPc"]),
  },
  methods: {
    fnToIntroduce(url) {
      this.$router.push({
        path: url,
      });
    },
    toOutSideUrl(file_url) {
      // console.log(file_url);
      window.open(file_url, "_blank");
    },
  },
  mounted() {
    setTimeout(() => {
      this.$zhTran();
    }, 300);
    if (document.body.clientHeight < window.screen.height) {
      // this.isfixed=true
    }
    // console.log('document.body.clientHeight====',document.body.clientHeight)
    // console.log('window.screen.height====',window.screen.height)
    //获取页面元素所占的高度及窗口高度
  },
};
</script>

<style lang="less" scoped>
.isfixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-top: 100px;
}

.el-footer {
  .el-main {
    width: 1200px;
    margin: 0 auto;
  }

  // margin-top: 20px;
  background: #333132;
  padding: 36px 0 20px;
  height: auto !important;
  color: #afafaf;
  text-align: center;

  .association_detail {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    margin-bottom: 40px;

    .association_detail_left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-top: 40px;

      div {
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 10px;
      }

      div:before {
        font-size: 20px;
        margin-right: 10px;
        vertical-align: middle;
      }
    }

    .association_detail_right {
      display: flex;

      ul {
        padding: 0 40px;
        text-align: left;
        position: relative;
        font-family: "MicrosoftYaHei";
        font-size: 14px;
        color: #888888;
        letter-spacing: 0;
        line-height: 30px;
        font-weight: 400;

        li {
          cursor: pointer;
        }

        li:hover {
          color: #fff;
        }

        .vertical_line {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0;
          height: 62px;
          width: 1px;
          background: #3e3d3c;
        }
      }
    }
  }

  /deep/.copyright_info {
    font-family: "MicrosoftYaHei";
    font-size: 14px;
    color: #888888;
    letter-spacing: 0;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 20px;

    a {
      color: #888888 !important;
    }
  }
}

.m-footer {
  padding: 20px;

  .association_detail_left {
    flex-direction: column;
    display: flex;

    div {
      padding: 5px 0;
      line-height: 20px;
    }
  }

  .copyright_info {
    margin-top: 20px;
  }
}

.qcode {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;

  .qcode-item {
    width: 24%;

    img {
      width: 100%;
    }
  }
}

.link {
  padding-bottom: 50px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  h5 {
    font-family: "MicrosoftYaHei";
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 400;
    text-align: left;
    line-height: 26px;
    margin-bottom: 20px;
  }

  ul li {
    float: left;
    margin-right: 20px;
    margin-bottom: 10px;
  }

  span {
    cursor: pointer;
    font-family: "MicrosoftYaHei";
    font-size: 14px;
    color: #888888;
    letter-spacing: 0;
    font-weight: 400;
  }

  span:hover {
    text-decoration: underline;
    color: #ffffff;
  }

  .el-image {
    width: 145px;
    height: 58px;
  }
}
</style>
